import React from 'react';

import {StdBox} from './styles';



const Button =  ({text, disabled, backColor = 'rgb(0,30,80)', color= '#fff', hoverColor= 'rgb(0, 64, 197)', borderColor= 'rgb(0,30,80)', handle}) => {
  return (
    <>
      <StdBox
        onClick={handle}
        disabled={disabled}
        color={disabled ? 'rgb(60, 72, 77)' : color ? color : '#fff'}
        backColor={disabled ? 'rgb(194, 202, 207)' : backColor ? backColor : 'rgb(0,30,80)'}
        hoverColor={hoverColor ? hoverColor : 'rgb(0, 64, 197)'}
        borderColor={disabled ? 'none' : borderColor ? borderColor : 'rgb(0,30,80)'}
        >
        {text}
      </StdBox>
    </>
  );
};
export default Button;
